<!-- example 6 - center on mobile -->
<nav class="navbar fixed-top  navbar-expand-md navbar-light bg-white ">
    <div class="d-flex flex-grow-1 ">
        <span class="w-100 d-md-none d-block"><!-- hidden spacer to center brand on mobile --></span>
        <a class="navbar-brand d-none d-md-inline-block" href="#">
            <img src="../../../../assets/brand/LogoTrans.png" width="130" style="height: auto;" alt="" loading="lazy" class="ml-2">
        </a>
        <a class="navbar-brand-two mx-auto d-md-none d-inline-block" href="#">
            <img src="../../../../assets/brand/LogoTrans.png" width="80" style="height: auto;" alt="" loading="lazy" class="mt-1">
        </a>
        <div class="w-100 text-right">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#myNavbar" style="    margin: 10px;">
                <span class="navbar-toggler-icon"></span>
            </button>
        </div>
    </div>
    <div class="collapse navbar-collapse flex-grow-1 text-right" id="myNavbar">
        <ul class="navbar-nav ml-auto flex-nowrap">
            <li class="nav-item " routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }">
                <a class="nav-link" [routerLink]="['/inicio']"  (click)="closeNavbar()">
                    <h4>Inicio</h4>
                </a>
            </li>
            <li class="nav-item" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }">
                <a class="nav-link" [routerLink]="['/venta']"  (click)="closeNavbar()">
                    <h4>Venta</h4>
                </a>
            </li>
            <li class="nav-item" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }">
                <a class="nav-link" [routerLink]="['/alquiler']"  (click)="closeNavbar()">
                    <h4>Alquiler</h4>
                </a>
            </li>
            <!-- <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" [routerLink]="['/contacto']">
                    <h4>Contacto</h4>
                </a>
            </li> -->
           <li *ngIf="admin" class="nav-item dropdown" [routerLinkActive]="['active']">
  <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown">
    <i class="fas fa-cogs"></i> Administrador
  </a>
  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
    <div class="dropdown-divider"></div>
    <a class="dropdown-item" [routerLink]="['/admin/principal']">
      <i class="fas fa-users-cog"></i> Propiedades
    </a>
    <a class="dropdown-item" [routerLink]="['SisInm/Auditoria']">
      <i class="fas fa-book"></i> Catálogos
    </a>
    <div class="dropdown-divider"></div>
    <a class="dropdown-item">
      <app-logout></app-logout>
    </a>
  </div>
</li>

        </ul>

    </div>
</nav>